import { ProductStockStatus } from "@shared_packages/toolkit/types";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { SearchFieldType } from "../../../../components/advanced-search/AdvancedSearch.interface";
import { AdvancedSearch } from "../../../../components/advanced-search/AdvancedSearch";
import { AnimateAppearanceWrapper } from "../../../../components/animate-appearence/AnimateAppearanceWrapper";
import { FilterTabs, PageTitle } from "../../../../components/ui-kit";
import { useTableContext } from "../../../../components/ui-kit/ReactTable/context/TableContext";
import ProductsTable from "../components/ProductsTable";
import { productsSearchConfig } from "../config/searchConfig";
import { useGetProducts, ProductsFilters } from "../hooks/useProducts";
import { ISortConfig } from "../../../../components/ui-kit/ReactTable/context/TableContext";

const Container = styled.div<{ details?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ details }) => details && "margin-top: 30px;"}
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const TableContainer = styled.div<{ details?: boolean }>`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  ${({ details }) =>
    !details &&
    `border: 1px solid #eeeeee;
    border-radius: 10px;
    padding: 30px 20px;`}
  box-sizing: border-box;

  @media (max-width: 900px) {
    padding: ${({ details }) => (details ? "0" : "12px")};
  }
`;

const tabsConfig = [
  {
    name: "All",
    value: undefined,
  },
  {
    name: "High",
    value: ProductStockStatus.HIGH,
  },
  {
    name: "Medium",
    value: ProductStockStatus.MEDIUM,
  },
  {
    name: "Low",
    value: ProductStockStatus.LOW,
  },
  {
    name: "Out of stock",
    value: ProductStockStatus.OUT_OF_STOCK,
  },
];
export interface ProductsListProps {
  ownerId?: string;
  details?: boolean;
}
export const ProductsList: React.FunctionComponent<ProductsListProps> = ({
  ownerId,
  details,
}) => {
  const { sortConfig } = useTableContext();
  const [filters, setFilters] = useState<ProductsFilters>({});
  const [sort, setSort] = useState<ISortConfig>(() => {
    // Initialize with sortConfig if available, otherwise use default
    return (
      sortConfig || {
        field: "createdAt",
        direction: "desc",
      }
    );
  });
  const [status, setStatus] = useState<ProductStockStatus | undefined>();

  const { products, onPaginationChange, totalDocs, limit, page, loading } =
    useGetProducts(filters, sort, status, ownerId);

  useEffect(() => {
    // Only update sort if sortConfig is defined and different from current sort
    if (
      sortConfig &&
      sortConfig.field &&
      (sortConfig.field !== sort.field ||
        sortConfig.direction !== sort.direction)
    ) {
      setSort(sortConfig);
    }
  }, [sortConfig, sort.field, sort.direction]);

  const searchConfig = ownerId
    ? productsSearchConfig.filter(
        (field) => field.type !== SearchFieldType.SEARCH_BY_COMPANY_DROPDOWN
      )
    : productsSearchConfig;

  return (
    <AnimateAppearanceWrapper>
      <Container details={details}>
        <TopLine>
          <PageTitle
            title="Products"
            // subtitle="Whole data about your business here"
          />
        </TopLine>
        <TableContainer details={details}>
          <FilterTabs
            menus={tabsConfig}
            clickHandler={(val) => setStatus(val as ProductStockStatus)}
            startWithIndex={0}
          />
          <AdvancedSearch config={searchConfig} onChange={setFilters} />
          <ProductsTable
            data={products}
            pagination={{ page, limit, totalDocs, onPaginationChange }}
          />
        </TableContainer>
      </Container>
    </AnimateAppearanceWrapper>
  );
};
